/**
 * Функция скролла до элемента
 * @param classId наименование id элемента
 */
export const scrollTo = (classId: string) => {
  const element = document.getElementById(classId)
  element !== null && element.scrollIntoView();
}

/**
 * Скачивание файла по ссылке
 * @param url ссылка
 * @param fileName имя файла
 */
export const downloadFile = (url: string, fileName: string) => {
  fetch(url)
    .then(res => res.blob())
    .then(res => {
      const aElement = document.createElement('a');
      aElement.setAttribute('download', fileName);
      const href = URL.createObjectURL(res);
      aElement.href = href;
      aElement.setAttribute('target', '_blank');
      aElement.click();
      URL.revokeObjectURL(href);
    });
}

const pdfRegex = /.pdf$/gm;
const zipRegex = /.zip$/gm;
const getPdfImage = (url : string): boolean => {
  const res = url.match(pdfRegex)
  return res !== null;
}
const getZipImage = (url : string): boolean => {
  const res = url.match(zipRegex)
  return res !== null;
}
export const checkRegex = (url : string, preview_image?: string | undefined) => {
  if (preview_image !== undefined && preview_image.length !== 0) {
    return preview_image;
  }
  else if (getPdfImage(url)) {
    return `${process.env.REACT_APP_DJANGO_DOMEN}/images/Others/pdf.png`
  } else if (getZipImage(url)) {
    return `${process.env.REACT_APP_DJANGO_DOMEN}/images/Others/zip.png`
  } else return undefined;
}

export const getLocationName = (name: string) => {
  if (name === '/catalog') {
    return 'Каталог'
  }
  if (name === '/certificates') {
    return 'Сертификаты'
  }
  if (name === '/flyers') {
    return 'Листовки'
  }
}
